import React, { useEffect } from "react";
import AthleteCard from "./AthleteCard";
import Combine from "./Combine";
import Coaches from "../../common/coaches/Coaches";

function AdminDashboard() {
  useEffect(() => {
    // Disable scrolling when the component mounts
    document.body.style.overflow = "auto";

    return () => {
      // Restore scrolling when the component unmounts
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="h-[1000px] lg:h-screen bg-gray-200 p-4 overflow-y-auto pb-24 lg:pb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 auto-rows-fr h-full">
        {/* Full height Combines Card */}
        <div className="bg-white rounded-lg shadow-md p-0 md:row-span-2 flex flex-col min-h-0 max-h-[500px] md:max-h-none">
          <div className="flex-1 overflow-y-auto lg:overflow-y-hidden">
            <AthleteCard isAdmin={true} />
          </div>
        </div>

        {/* Athletes Card */}
        <div className="bg-white rounded-lg shadow-md flex flex-col p-0 min-h-0 max-h-[500px] md:max-h-none">
          <div className="flex-1 overflow-y-auto lg:overflow-y-hidden">
            <Combine />
          </div>
        </div>

        {/* Coaches Card */}
        <div className="bg-white rounded-lg shadow-md flex flex-col p-0 min-h-0 max-h-[500px] md:max-h-none">
          <div className="flex-1 overflow-y-auto lg:overflow-y-hidden">
            <Coaches />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
